import { parseISO, format } from 'date-fns';

export function formatMoney(value) {
  if (!value && value !== 0) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function formatDate(value) {
  if (!value) return 'N/A';
  
  return format(parseISO(value), 'dd/MM/yyyy');
}
